/*============================================================================
  DiamondBoss consultation form (snippets/db-consultation-form.liquid)
  One question per step, validated before moving on, submitted to Formspree via fetch.
==============================================================================*/
;(function () {
  document.querySelectorAll('[data-db-consult]').forEach(function (form) {
    var steps = Array.prototype.slice.call(form.querySelectorAll('[data-step]'))
    var nextBtn = form.querySelector('[data-next]')
    var backBtn = form.querySelector('[data-back]')
    var errorEl = form.querySelector('[data-error]')
    var countEl = form.querySelector('[data-step-count]')
    var bar = form.querySelector('[data-progress-bar]')
    var done = form.parentElement.querySelector('[data-done]')
    var current = 0
    var questions = steps.length - 1 // first step is the welcome screen

    var dateInput = form.querySelector('[data-min-today]')
    if (dateInput) {
      var d = new Date()
      dateInput.min = [d.getFullYear(), String(d.getMonth() + 1).padStart(2, '0'), String(d.getDate()).padStart(2, '0')].join('-')
    }

    var otherWrap = form.querySelector('[data-other-budget]')
    var otherInput = otherWrap && otherWrap.querySelector('input')
    form.querySelectorAll('input[name="budget"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        var isOther = radio.value === 'other' && radio.checked
        otherWrap.hidden = !isOther
        otherInput.required = isOther
        if (isOther) otherInput.focus()
        else otherInput.value = ''
      })
    })

    function showError(msg) {
      errorEl.textContent = msg
      errorEl.hidden = !msg
    }

    function render(focus) {
      steps.forEach(function (s, i) {
        s.classList.toggle('is-active', i === current)
      })
      backBtn.hidden = current === 0
      var last = current === steps.length - 1
      nextBtn.textContent = current === 0 ? 'Start' : last ? 'Submit' : 'Next'
      countEl.textContent = current === 0 ? '' : 'Question ' + current + ' of ' + questions
      bar.style.width = (current / questions) * 100 + '%'
      showError('')
      if (focus) {
        var target = steps[current].querySelector('input:not([type="hidden"])') || steps[current]
        target.focus({ preventScroll: true })
        form.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    }

    function stepIsValid() {
      var fields = steps[current].querySelectorAll('input, select, textarea')
      for (var i = 0; i < fields.length; i++) {
        var f = fields[i]
        if (f.closest('[hidden]')) continue
        if (!f.checkValidity()) {
          var msg = f.type === 'radio' ? 'Please choose an option to continue.' : f.validationMessage
          showError(msg)
          if (f.type !== 'radio') f.focus()
          return false
        }
      }
      return true
    }

    function submit() {
      nextBtn.disabled = true
      nextBtn.textContent = 'Sending…'
      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' }
      })
        .then(function (res) {
          if (!res.ok) throw new Error('bad status')
          form.hidden = true
          done.hidden = false
          done.focus()
          window.dataLayer = window.dataLayer || []
          window.dataLayer.push({ event: 'consultation_submitted', form: form.querySelector('[name="form"]').value })
        })
        .catch(function () {
          nextBtn.disabled = false
          nextBtn.textContent = 'Submit'
          showError('We couldn’t send your request. Please check your connection and try again, or message us on WhatsApp.')
        })
    }

    nextBtn.addEventListener('click', function () {
      if (!stepIsValid()) return
      if (current === steps.length - 1) return submit()
      current++
      render(true)
    })

    backBtn.addEventListener('click', function () {
      if (current === 0) return
      current--
      render(true)
    })

    // Enter moves forward instead of submitting the whole form early
    form.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.tagName === 'INPUT') {
        e.preventDefault()
        nextBtn.click()
      }
    })
    form.addEventListener('submit', function (e) {
      e.preventDefault()
      nextBtn.click()
    })

    render(false)
  })
})()
